module.exports = __webpack_public_path__ + "static/media/R-300HD_CrossSection.081b887a.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/en/R-300HD_CrossSection.png
// module id = 479
// module chunks = 0